import { useQuery } from '@tanstack/react-query';
import { getMembershipPrices, getPriceList } from './price.api';

export function usePriceList(groupId: number) {
  return useQuery({
    queryKey: ['options', 'priceList', groupId],
    queryFn: () => getPriceList(groupId),
    enabled: !!groupId,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
}
export function useMembershipList() {
  return useQuery({
    queryKey: ['options', 'membershipList'],
    queryFn: () => getMembershipPrices(),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
}
